.categoryTabContainer {
  margin-top: 16px;
}

.wizardBanner {
  margin-left: 16px;
  margin-right: 16px;
}

@media all and (--reefer-media-tablet-min) {
  .categoryTabContainer {
    margin-top: 0px;
  }

  .wizardBanner {
    margin-left: 0px;
    margin-right: 0px;
  }
}
